import React, { useContext } from 'react';
import Products from './components/Products';
import {ProductsContext, CheckoutsContext, CartContext} from "./components/products/productsContext"
import Client from 'shopify-buy';

const ProductList = () => {
  // eslint-disable-next-line
  let products = useContext(ProductsContext)
  // eslint-disable-next-line
  const [checkout, setCheckout] = useContext(CheckoutsContext)
  // eslint-disable-next-line 
  const [showCart, setShowCart] = useContext(CartContext)

  const client = Client.buildClient({
    domain: 'conecuh-brands.myshopify.com',
    storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
  });
 
  return (                    
      <div className="App">   
        <button className="cart-button mobile-view" style={(checkout.lineItems.length>0&&!showCart)?{}:{display:"none"}} 
        onClick={()=> setShowCart(true)}>
          <div style={{ fontSize:"27px",color: "white" }}>{checkout.lineItems.length}</div>
          <img style={{height:"39px",marginLeft: "12px"}} src={require("./components/images/cart.png")}  alt="Icon not avilable"></img>
        </button>
        <Products
          shirts={products.shirts}
          hats={products.hats} 
          accessarries={products.accessarries}
          client={client}
        />
      </div>
  );
}
export default ProductList;



// WEBPACK FOOTER //
// ./src/ProductList.js